import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const Collapsed = () => (
  <div className="flex flex-col gap-2 p-2">
    <Skeleton className="w-full" style={{ height: '145px' }} />
    <Skeleton className="h-2.5 w-full" />
    <Skeleton className="h-2.5 w-full" />
    <Skeleton className="h-2.5 w-full" />
  </div>
);
